import { render, staticRenderFns } from "./FeConsultoria.vue?vue&type=template&id=054483df&"
import script from "./FeConsultoria.vue?vue&type=script&lang=js&"
export * from "./FeConsultoria.vue?vue&type=script&lang=js&"
import style0 from "./FeConsultoria.vue?vue&type=style&index=0&id=054483df&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports